const featureItems = [
  {
    title: '全部章节无删减',
    desc: '承诺每一部漫画完整呈现，不做任何删减处理，保留原汁原味的漫画内容。',
    icon: 'ri-file-check-line',
    color: 'primary',
  },
  {
    title: '下拉式竖屏阅读',
    desc: '专为移动端优化的竖屏阅读体验，下滑即可连续阅读，沉浸式追漫不间断。',
    icon: 'ri-scroll-to-bottom-line',
    color: 'accent',
  },
  {
    title: '免费在线阅读',
    desc: '全部漫画资源免费提供，在线看入口直达，无需注册即可畅享全部章节。',
    icon: 'ri-vip-crown-line',
    color: 'secondary',
  },
  {
    title: '每日同步更新',
    desc: '热门连载作品每日同步更新最新章节，第一时间追到最精彩的剧情发展。',
    icon: 'ri-refresh-line',
    color: 'primary',
  },
  {
    title: '海量漫画资源',
    desc: '收录2000+部热门漫画，涵盖热血、恋爱、悬疑、奇幻等多元题材。',
    icon: 'ri-stack-line',
    color: 'accent',
  },
];

export default function FeaturesSection() {
  const colorMap: Record<string, { bg: string; icon: string; border: string }> = {
    primary: { bg: 'bg-primary-100', icon: 'text-primary-500', border: 'border-primary-200/40' },
    accent: { bg: 'bg-accent-100', icon: 'text-accent-500', border: 'border-accent-200/40' },
    secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-500', border: 'border-secondary-200/40' },
  };

  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <div
                key={i}
                className={`group bg-background-50 rounded-xl p-6 border ${c.border} hover:border-primary-300/60 transition-all duration-300 text-center cursor-pointer`}
              >
                <div
                  className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl ${c.bg} flex items-center justify-center mx-auto mb-4`}
                >
                  <i className={`${item.icon} text-2xl ${c.icon}`}></i>
                </div>
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}